<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav v-if="false">
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/dashboard'}">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright center">
        &copy; {{year}} Kristu Jayanti (Deemed to be University) <br>Developed by <a href="http://www.three38inc.com/"><img src="https://kjc.sgp1.digitaloceanspaces.com/misc/logo-full-black.png" alt="three38-logo" /></a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.copyright img{
  margin: 0 5px;
}
</style>
